import React from "react";
import { Input } from "antd";
import styles from "./FormInput.module.scss";

export const FormInputWhite = ({ ...rest }) => {
  return <Input {...rest} className={styles.input} />;
};
